














































































import Vue from 'vue'
import IndexButton from './IndexButton.vue'
import { mapGetters, mapMutations } from 'vuex'
import { USER_NS } from '~/store/modules/shared/user/state'
import IndexSearchbar from '~/components/car/classifieds/index/jumbotron/IndexSearchbar.vue'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import TaglineText from '~/components/car/classifieds/index/jumbotron/TaglineText.vue'
import OfferButtonMobile from '~/components/car/header/OfferButtonMobile.vue'
import { ciLayout } from '~/icons/source/solid/layout'
import IndexSlider from '~/components/car/IndexSlider.vue'
import { mapDeps } from '~/plugins/dependency-container/utils'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { capitalizeAllWords } from '~/utils/string'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import CGoogleAd from '~/components/shared/configurable/ad/CGoogleAd.vue'
import { AccessToggleName } from '~/models/user/access-toggles'
import { CategoryId } from '~/models/category/types'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { SET_SEARCH_TYPE } from '~/store/modules/shared/classifieds/search/mutation-types'

export default Vue.extend({
  components: {
    CGoogleAd,
    IndexSlider,
    OfferButtonMobile,
    TaglineText,
    IndexSearchbar,
    IndexButton
  },
  data() {
    return {
      desktopHrefLink: '/quick-search/vehicles/cars',
      selectedSearchbarCategory: CategoryId.VEHICLES
    }
  },
  computed: {
    ...mapGetters(USER_NS, {
      isDealer: 'isOfTypeDealer',
      isAuditsUser: 'isAuditsUser',
      isAdmin: 'isAdmin',
      userHasAccessTo: 'userHasAccessTo'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isPc: 'isPc',
      isMobile: 'isMobile',
      isTablet: 'isTablet'
    }),
    ...mapDeps({
      legacyUrlService: LegacyUrlService
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    userHasAccessToQuickSearch() {
      return this.userHasAccessTo(AccessToggleName.NEW_CATEGORIES_SEARCH_PAGE)
    },
    icons() {
      return {
        categories: ciLayout,
        plus: faPlus
      }
    },
    searchBtnText() {
      return this.$t('search')
    },
    searchHref() {
      if (this.userHasAccessToQuickSearch) {
        return this.isPc ? this.desktopHrefLink : '/quick-search/'
      }
      return '/classifieds/search/'
    }
  },
  methods: {
    ...mapMutations(CLASSIFIED_SEARCH_NS, {
      setSearchType: SET_SEARCH_TYPE
    }),
    configureSearchTargetLink(categoryId: CategoryId) {
      this.selectedSearchbarCategory = categoryId
      switch (categoryId) {
        case CategoryId.PARTS:
          this.desktopHrefLink = '/quick-search/parts/for-cars'
          break
        case CategoryId.XYMA:
          this.desktopHrefLink = '/quick-search/xyma'
          break
        case CategoryId.PLOT:
          this.desktopHrefLink = '/quick-search/plot'
          break
        case CategoryId.JOBS:
          this.desktopHrefLink = '/jobs'
          break
        default:
          this.desktopHrefLink = '/quick-search/vehicles/cars'
          break
      }
    },
    handleMobileQuickSearchOpener(e: Event) {
      this.selectedSearchbarCategory === CategoryId.PLOT &&
        this.setSearchType(true)

      if (this.isPc || !this.userHasAccessToQuickSearch) return

      e.preventDefault()
      this.$emit('open-quick-search', this.selectedSearchbarCategory)
    }
  },
  setup() {
    return { capitalizeAllWords }
  }
})
